import {closeModal, openModal} from "../../modal/modal"

const balikovnaParcelItems = document.querySelectorAll<HTMLElement>(".i-balikovna-parcel")

balikovnaParcelItems.forEach((item) => {
  const radio = item.closest(".f-radio-box")
  const radioInput = radio?.querySelector<HTMLInputElement>(".f-radio-box__input")
  const hiddenInputs = document.querySelectorAll<HTMLInputElement>(".f-radio-box__balikovna-hidden-input")
  const resultInput = radio?.querySelector<HTMLInputElement>(".f-radio-box__balikovna-hidden-input input")
  const countrySelect = document.querySelector<HTMLSelectElement>(".s-shipping-payment__country-select select")
  const changeParcelLink = radio?.querySelector(".f-radio-box__link")
  const balikovnaModal = radio?.querySelector<HTMLElement>(".m-balikovna")

  const loadBalikovnaIframe = () => {
    const iframe = balikovnaModal?.querySelector("iframe")

    if (iframe && !iframe.classList.contains("--loaded")) {
      iframe.src = iframe.getAttribute("defer-src") ?? ""
      iframe.classList.add("--loaded")
    }
  }

  const disableIframeHiddenInputs = () => {
    hiddenInputs.forEach((input) => (input.disabled = true))
  }

  const setResultInputValue = (value: string) => {
    if (!resultInput) return

    disableIframeHiddenInputs()
    resultInput.disabled = false
    resultInput.value = value
  }

  const balikovnaCallback = (point) => {
    item.classList.add("d-none")
    changeParcelLink?.classList.add("--hidden")
    if (radioInput) {
      radioInput.checked = false
    }

    if (point) {
      changeParcelLink?.classList.remove("--hidden")
      item.classList.remove("d-none")
      if (radioInput) {
        radioInput.checked = true
      }

      if (resultInput) {
        const balikovnaInfo = {
          id: point.id,
          name: point.name,
          address: point.address,
          description: point.description,
          street: point.street,
          city: point.city,
          zip: point.zip,
        }
        setResultInputValue(JSON.stringify(balikovnaInfo))
      }

      const balikovnaInfo: balikovnaOptions = {
        name: point.name as string,
        city: point.city as string,
        zip: point.zip as string,
        address: point.address as string,
        openingHours: point.opening_hours as Array<object>,
        description: point.description,
      }
      setBalikovnaValues(item, balikovnaInfo)

      if (radioInput) {
        radioInput.checked = true
        radioInput.dispatchEvent(new Event("change"))
      }
    }

    if (balikovnaModal) closeModal(balikovnaModal)
  }

  radio?.addEventListener("click", () => {
    /* const country = countrySelect ? countrySelect.selectedOptions[0].value : ""
    if (country) balikovnaOptions.country = country.toLowerCase() */
    if (item.classList.contains("d-none")) {
      loadBalikovnaIframe()
    } else if (radioInput) {
      radioInput.checked = true
      radioInput.dispatchEvent(new Event("change"))
    }
  })

  changeParcelLink?.addEventListener("click", (e) => {
    e.preventDefault()
    loadBalikovnaIframe()
    if (balikovnaModal) openModal(balikovnaModal)
  })

  countrySelect?.addEventListener("change", () => {
    disableIframeHiddenInputs()
    setResultInputValue("")
    setBalikovnaValues(item, null, true)
    item.classList.add("d-none")
    changeParcelLink?.classList.add("--hidden")
  })

  window.addEventListener("message", (event) => {
    if (event.data.message === "pickerResult") {
      console.log(event.data)
      balikovnaCallback(event.data.point)
    }
  })
})

export const setBalikovnaValues = (item: HTMLElement, balikovnaOptions: balikovnaOptions, clear = false) => {
  const nameElement = item.querySelector<HTMLElement>(".i-balikovna-parcel__name")
  const cityElement = item.querySelector<HTMLElement>(".i-balikovna-parcel__city")
  const zipElement = item.querySelector<HTMLElement>(".i-balikovna-parcel__zip")
  const addressElement = item.querySelector<HTMLElement>(".i-balikovna-parcel__address")
  const openingElement = item.querySelector<HTMLElement>(".i-balikovna-parcel__opening-hours-table")
  const descriptionElement = item.querySelector<HTMLElement>(".i-balikovna-parcel__description")

  if (clear) {
    if (nameElement) nameElement.innerHTML = ""
    if (cityElement) cityElement.innerHTML = ""
    if (zipElement) zipElement.innerHTML = ""
    if (addressElement) addressElement.innerHTML = ""
    if (openingElement) openingElement.innerHTML = ""
    if (descriptionElement) descriptionElement.innerHTML = ""
    return
  }

  if (nameElement) nameElement.innerHTML = balikovnaOptions.name
  if (cityElement) cityElement.innerHTML = balikovnaOptions.city
  if (zipElement) zipElement.innerHTML = balikovnaOptions.zip
  if (addressElement) addressElement.innerHTML = balikovnaOptions.address
  if (openingElement) setOpeningHours(openingElement, balikovnaOptions.openingHours)
  if (descriptionElement) descriptionElement.innerHTML = balikovnaOptions.description
}

export type balikovnaOptions = {
  name: string
  city: string
  zip: string
  address: string
  openingHours: Array<object>
  description: string
}

const setOpeningHours = (tableWrapper: HTMLElement, openingHours: Array<object>) => {
  if (!tableWrapper) return

  const days = ["Pondělí", "Úterý", "Středa", "Čtvrtek", "Pátek", "Sobota", "Neděle"]
  const openningHoursElement = document.createDocumentFragment()
  const table = openningHoursElement.appendChild(document.createElement("table"))
  table.setAttribute("cellpadding", "5")

  days.forEach((day, index) => {
    const openingObject = openingHours[index]
    const tableRow = table.appendChild(document.createElement("tr"))

    const tableDataName = tableRow.appendChild(document.createElement("td")).appendChild(document.createElement("strong"))
    tableDataName.innerHTML = `${day}: `

    const tableDataOpening = tableRow.appendChild(document.createElement("td"))

    if (openingObject) {
      tableDataOpening.innerHTML = `${openingObject[0]["od"]}  - ${openingObject[0]["do"]}`
    } else {
      tableDataOpening.innerHTML = "Zavřeno"
    }
  })

  tableWrapper.innerHTML = ""
  tableWrapper.appendChild(table)
}
